import { isString } from 'underscore'
import { setSentryExtra } from '@/common/util/sentry'

export const getUrlParam = (url, param) => {
  if (!url) return null
  const regexp = url.match(/([^?=&]+)(=([^&]*))/g)
  if (!regexp) return null
  const params = regexp.reduce((a, v) => {
    return (a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a
  }, {})
  return params[param]
}

export const getHost = url => {
  const matches = url.match(
    /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/g
  )
  if (matches.length !== 1) return null
  return matches[0]
}

export const getDomainName = url => {
  return getHost(url).replace(/http:\/\/|https:\/\//g, '')
}

export const isLoadedLocally = URL => {
  return URL.indexOf('file://') === 0
}

export const readHash = () => {
  const hash = (globalThis.__TEST_LOCATION__ ?? window.location).hash
  if (hash) {
    let hashInfo = hash.substring(1)
    hashInfo = decodeURIComponent(hashInfo)
    setSentryExtra('hash', hashInfo)
    window.FIELD_CONFIGURATION = JSON.parse(hashInfo)
  }
}

export const isValidUrl = url => {
  try {
    new URL(url)
    return true
  } catch {
    return false
  }
}

export const isValidPath = path => {
  if (!isString(path)) return false
  return /^(\/[^\/]+){0,}\/?$/.test(path)
}

export const getValidUrl = url => {
  if (isValidUrl(url)) return new URL(url).href
  if (isValidPath(url)) {
    const origin = (globalThis.__TEST_LOCATION__ ?? window.location).origin
    return new URL(url, origin).href
  }
  return null
}

/**
 * @param {*} url base url to which query parameters will be appended
 * @param {object} params object with key-value pairs to be appended as query parameters
 * @returns {string} url with appended query parameters
 */
export const appendQueryParams = (url, params) => {
  const urlObj = new URL(url)
  Object.entries(params).forEach(([key, value]) => {
    urlObj.searchParams.append(key, value)
  })
  return urlObj.href
}
